// Services
import callAPI from "../callApi";
import path from "../variables";

/**
 * Recherche globale multi-ressources (barre du haut).
 */
const Search = {
	/**
	 * Recherche transverse — `params` : "?search=<terme>".
	 * Renvoie { term, groups: [ { type, label, items } ] }.
	 */
	global: (params?: any) =>
		callAPI("GET", `${path.base}/search${params ? params : ""}`, "", "global search"),

	/**
	 * Détail d'un enregistrement — `params` : "?type=<type>&id=<uuid>".
	 * Renvoie { type, title, fields: [ {label, value} ] }.
	 */
	detail: (params?: any) =>
		callAPI(
			"GET",
			`${path.base}/search/detail${params ? params : ""}`,
			"",
			"global search detail",
		),
};

export default Search;
